module.exports = __webpack_public_path__ + "img/restaurant-5.212d8a52.jpg";